import type { FC } from 'react';
import { Switch, Route as ReactRoute } from 'react-router-dom';

import { NotFound } from '/common/NotFound';

import Route from './Route';
import type { IRouteProps } from './models/IRouteProps';

interface IRoutesListProps {
  routes: IRouteProps[];
}

export const RoutesList: FC<IRoutesListProps> = ({ routes = [] }) => (
  <Switch>
    {routes.map((route: IRouteProps, i: number) => (
      <Route key={i} {...route} />
    ))}

    <ReactRoute component={NotFound} />
  </Switch>
);
